import { render, staticRenderFns } from "./position-notice.vue?vue&type=template&id=3ddea932&scoped=true";
import script from "./position-notice.vue?vue&type=script&lang=js";
export * from "./position-notice.vue?vue&type=script&lang=js";
import style0 from "./position-notice.vue?vue&type=style&index=0&id=3ddea932&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "3ddea932", null);
export default component.exports;